module.exports = __webpack_public_path__ + "static/media/banner-manual-do-transportador-tablet-maxi-frete.5c85b5fb.png";